import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Link, Text } from 'lusha-ui-components-v2';
import React from 'react';
import { IconFactory } from '../../assets/icons/IconFactory';
import './ErrorScreen.scss';
import { css } from '@emotion/react';
function ErrorScreen() {
    return (_jsxs("div", { className: "error-screen-container", children: [_jsx("div", { className: "error-screen-img", children: IconFactory('Error') }), _jsxs("div", { css: css `
          width: 80%;
          max-width: 360px;

          .error-screen-title {
            margin-bottom: 8px;
          }

          .error-screen-text {
            margin-bottom: 24px;
          }

          .error-screen-support {
            display: inline-block;
            margin-left: 4px;
          }
        `, children: [_jsx(Text, { className: "error-screen-title", variant: "largeM", color: "seriousBlack", children: "Something went wrong" }), _jsx(Text, { className: "error-screen-text", variant: "mediumR", color: "seriousBlack", children: "Please refresh your browser or try again later" }), _jsx("div", { className: "error-screen-details-container", children: _jsxs(Text, { className: "error-screen-details", variant: "tinyR", color: "darkGrey", children: ["In case the problem continues, please contact our", _jsx(Link, { className: "error-screen-support", size: "tiny", href: "https://info.lusha.com/en/", target: "_blank", children: "support team" })] }) })] })] }));
}
export default ErrorScreen;
